"use client"
//logica scanner web npms
//npm install @zxing/library @zxing/browser
import { useState, useEffect, useContext } from "react"
import { DataGrid } from "@mui/x-data-grid"
import Paper from "@mui/material/Paper"
import EditIcon from "@mui/icons-material/Edit"
import CloseIcon from "@mui/icons-material/Close"
import WarningIcon from "@mui/icons-material/Warning"
import InventoryIcon from "@mui/icons-material/Inventory"
import DeleteIcon from "@mui/icons-material/Delete" // Importando icono de eliminar
import { ErpContext } from "../../context/ErpContext.js"
import CreateItemComponentModal from "./CreateItemComponentModal.js"
import CustomPagination from "../transaccionComponent/CustomPagination.js"
import BuscadorItemsUbicaciones from "./BuscadorItemsUbicaciones.js"
import SpinnerLading from "../misc/SpinnerComponent.js"
import GestionGenerarCompraComponent from "../transaccionComponent/GestionGenerarCompraComponent.js"
import BarcodeIcon from "@mui/icons-material/QrCode"
import LocationOnIcon from "@mui/icons-material/LocationOn"
import TuneIcon from "@mui/icons-material/Tune"
import FileDownloadIcon from "@mui/icons-material/FileDownload"
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered"
import RestaurantIcon from "@mui/icons-material/Restaurant"
import NewReleasesIcon from "@mui/icons-material/NewReleases"
import FilterAltIcon from "@mui/icons-material/FilterAlt"
import SearchIcon from "@mui/icons-material/Search"
import ClearIcon from "@mui/icons-material/Clear"
import ChevronRightIcon from "@mui/icons-material/ChevronRight"
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner"
import CameraAltIcon from "@mui/icons-material/CameraAlt"
import Dialog from "@mui/material/Dialog"
import DialogTitle from "@mui/material/DialogTitle"
import DialogContent from "@mui/material/DialogContent"
import DialogActions from "@mui/material/DialogActions"
import CircularProgress from "@mui/material/CircularProgress"
import Alert from "@mui/material/Alert"

import {
  IconButton,
  Modal,
  Box,
  Button,
  Typography,
  Chip,
  Tooltip,
  alpha,
  useTheme,
  Checkbox,
  Drawer,
  Divider,
  TextField,
  InputAdornment,
  Badge,
  Autocomplete,
} from "@mui/material"

export default function InventarioComponent() {
  const theme = useTheme()

  const {
    getItemAndItemUbicacion,
    getUbicacion,
    getDeletedItemUbicacion,
    itemAtributoNoEliminados,
    getItemAtributoNoEliminados,
    isNavbarCollapsed,
    getParametrosGlobales,
    exportarPLUsBalanza,
    bulkDeleteItems,
    getValoresUnicosAtributo,
    formatStock,
    formatoFechasGlobal,
  } = useContext(ErpContext)

  const [itemEditable, setItemEditable] = useState([])
  const [openModal, setOpenModal] = useState(false)
  const [alignment, setAlignment] = useState("inventario")
  const [loading, setLoading] = useState(true)
  const [page, setPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [totalCount, setTotalCount] = useState(0)
  const [sortModel, setSortModel] = useState([])
  const [itemAndItemUbicacion, setItemAndItemUbicacion] = useState([])
  const [filters, setFilters] = useState({})
  const [selectedItems, setSelectedItems] = useState([])
  const [selectAll, setSelectAll] = useState(false)
  const [openCompraModal, setOpenCompraModal] = useState(false)
  const [compraData, setCompraData] = useState(null)
  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false)
  const [parametrosGlobales, setParametrosGlobales] = useState({})
  const [ubicacionSeleccionada, setUbicacionSeleccionada] = useState(null)
  const [soloItemsConPLU, setSoloItemsConPLU] = useState(false)

  const [filtroRecetas, setFiltroRecetas] = useState(false)
  const [filtroUltimosCreados, setFiltroUltimosCreados] = useState(false)
  const [filtroStockBajo, setFiltroStockBajo] = useState(false)

  const [mostrarFiltroAtributos, setMostrarFiltroAtributos] = useState(false)
  const [mostrarFiltroPLU, setMostrarFiltroPLU] = useState(false)
  const [filtrosAtributos, setFiltrosAtributos] = useState({})
  const [sugerenciasAtributos, setSugerenciasAtributos] = useState({})

  const [modoEliminacion, setModoEliminacion] = useState(false)
  const [itemsSeleccionadosParaEliminar, setItemsSeleccionadosParaEliminar] = useState([])
  const [openConfirmDeleteModal, setOpenConfirmDeleteModal] = useState(false)

  // Estados para el escáner QR/Barras
  const [isScannerActive, setIsScannerActive] = useState(false)
  const [scannerError, setScannerError] = useState(null)
  const [scannedCode, setScannedCode] = useState(null)
  const [isScanning, setIsScanning] = useState(false)
  const [scannerReader, setScannerReader] = useState(null)
  const [scannerInitialized, setScannerInitialized] = useState(false)
  const [scannedItemData, setScannedItemData] = useState(null)
  const [isScannedItemModalOpen, setIsScannedItemModalOpen] = useState(false)

  const showPluExport = parametrosGlobales?.pluBalanza === "1"

  const hayFiltroUbicacion = !!filters.ubicacionId
  const tipoEliminacion = hayFiltroUbicacion ? "itemUbicacion" : "itemCompleto"

  const attributeLabels = itemAtributoNoEliminados
    .filter((attr) => !attr.eliminado)
    .reduce((acc, attr, index) => {
      acc[`itemDatoAtributo${index + 1}`] = attr.descripcion
      return acc
    }, {})

  const scannedItem = scannedItemData?.item || null
  const scannedItemAttributes = scannedItem?.activeAttributes
    ? Object.entries(scannedItem.activeAttributes).filter(
        ([, value]) => value !== null && value !== undefined && String(value).trim() !== ""
      )
    : []

  const formatCurrency = (value) => {
    if (typeof value !== "number") return "Sin información"
    return value.toLocaleString("es-AR", { style: "currency", currency: "ARS" })
  }

  const getAttributeValue = (row, field) => {
    const value = row?.activeAttributes?.[field]
    if (value === null || value === undefined) return ""
    return String(value).trim()
  }

  const compareTextValues = (valueA, valueB) => {
    return String(valueA ?? "").localeCompare(String(valueB ?? ""), "es", {
      sensitivity: "base",
      numeric: true,
    })
  }

  const parseDateValue = (value) => {
    if (!value) return null

    if (value instanceof Date) {
      return Number.isNaN(value.getTime()) ? null : value
    }

    if (typeof value === "number") {
      const dateFromNumber = new Date(value)
      return Number.isNaN(dateFromNumber.getTime()) ? null : dateFromNumber
    }

    if (typeof value !== "string") {
      return null
    }

    const trimmedValue = value.trim()
    if (!trimmedValue) return null

    const normalizedValue = trimmedValue
      .toLowerCase()
      .replace(/\u00a0/g, " ")
      .replace(/a\.\s*m\.?/g, "am")
      .replace(/p\.\s*m\.?/g, "pm")
      .replace(/a\s*m\.?/g, "am")
      .replace(/p\s*m\.?/g, "pm")
      .replace(/\s+/g, " ")
      .trim()

    const formattedMatch = normalizedValue.match(
      /^(\d{1,2})\/(\d{1,2})\/(\d{4})(?:,)?\s+(\d{1,2}):(\d{2})(?:\s*(am|pm))?$/i,
    )

    if (formattedMatch) {
      const [, day, month, year, hoursText, minutesText, meridiem] = formattedMatch
      let hours = Number(hoursText)
      const minutes = Number(minutesText)

      if (meridiem === "am" && hours === 12) {
        hours = 0
      } else if (meridiem === "pm" && hours < 12) {
        hours += 12
      }

      const parsedDate = new Date(Number(year), Number(month) - 1, Number(day), hours, minutes)
      return Number.isNaN(parsedDate.getTime()) ? null : parsedDate
    }

    const isoDate = new Date(trimmedValue)
    return Number.isNaN(isoDate.getTime()) ? null : isoDate
  }

  const compareDateValues = (valueA, valueB) => {
    const dateA = parseDateValue(valueA)
    const dateB = parseDateValue(valueB)

    if (!dateA && !dateB) return 0
    if (!dateA) return -1
    if (!dateB) return 1

    return dateA.getTime() - dateB.getTime()
  }

  const currentSortField = sortModel[0]?.field || null
  const currentSortDirection = sortModel[0]?.sort || null

  useEffect(() => {
    setLoading(false)
  }, [itemAndItemUbicacion])

  useEffect(() => {
    if (itemAndItemUbicacion.length === 0) {
      setSelectedItems([])
      setSelectAll(false)
      setItemsSeleccionadosParaEliminar([]) // Limpiar selección de eliminación si no hay items
      setModoEliminacion(false) // Desactivar modo eliminación si no hay items
    }
  }, [itemAndItemUbicacion])

  useEffect(() => {
    const cargarParametrosGlobales = async () => {
      try {
        const parametros = await getParametrosGlobales(["pluBalanza", "fabricanteBalanza"])
        setParametrosGlobales(parametros)
      } catch (error) {
        console.error("Error al cargar parámetros globales:", error)
      }
    }

    cargarParametrosGlobales()
  }, [getParametrosGlobales])

  // useEffect para inicializar el escÃ¡ner cuando se abre el modal
  useEffect(() => {
    if (isScannerActive && !scannerInitialized) {
      const timer = setTimeout(() => {
        initializeScanner()
      }, 100) // Pequeño delay para asegurar que el DOM esté listo
      return () => clearTimeout(timer)
    }
  }, [isScannerActive, scannerInitialized])

  const toggleFilterDrawer = () => setFilterDrawerOpen(!filterDrawerOpen)

  const handleExportarPLUsBalanza = async () => {
    if (!ubicacionSeleccionada) {
      alert("Debe seleccionar una ubicación antes de exportar")
      return
    }

    try {
      await exportarPLUsBalanza(ubicacionSeleccionada)
    } catch (error) {
      console.error("Error al exportar PLUs de balanza:", error)
      alert("Error al exportar PLUs de balanza: " + error.message)
    }
  }

  const isExportButtonEnabled = () => {
    return parametrosGlobales?.pluBalanza === "1" && parametrosGlobales?.fabricanteBalanza && ubicacionSeleccionada
  }

  const handleToggleFiltroRecetas = () => {
    const newValue = !filtroRecetas
    setFiltroRecetas(newValue)
    setFilters((prev) => ({ ...prev, mostrarRecetas: newValue }))
    setPage(1)
  }

  const handleToggleFiltroUltimosCreados = () => {
    const newValue = !filtroUltimosCreados
    setFiltroUltimosCreados(newValue)
    setFilters((prev) => ({ ...prev, mostrarUltimosCreados: newValue }))
    setPage(1)
  }

  const handleToggleFiltroStockBajo = () => {
    const newValue = !filtroStockBajo
    setFiltroStockBajo(newValue)
    setFilters((prev) => ({ ...prev, soloStockBajo: newValue }))
    setPage(1)
  }

  const handleToggleFiltroPLU = () => {
    const newValue = !soloItemsConPLU
    setSoloItemsConPLU(newValue)
    setFilters((prev) => ({ ...prev, soloItemsConPLU: newValue }))
    setPage(1)
  }

  const mapearAtributosACampos = () => {
    return itemAtributoNoEliminados
      .filter((attr) => !attr.eliminado)
      .map((attr, index) => ({
        id: attr.id,
        descripcion: attr.descripcion,
        campo: `itemDatoAtributo${index + 1}`,
        index: index + 1,
      }))
  }

  const handleAtributoFilterChange = (campo, valor) => {
    setFiltrosAtributos((prev) => ({
      ...prev,
      [campo]: valor,
    }))
  }

  const cargarSugerenciasAtributo = async (campo, searchText) => {
    try {
      const valores = await getValoresUnicosAtributo(campo, searchText)
      setSugerenciasAtributos((prev) => ({
        ...prev,
        [campo]: valores,
      }))
    } catch (error) {
      console.error(`Error al cargar sugerencias del atributo ${campo}:`, error)
    }
  }

  const handleAplicarFiltrosAtributos = () => {
    fetchData(
      filters.ubicacionId,
      filters.itemId,
      filters.precio,
      filters.soloStockBajo,
      filters.mostrarUltimosCreados,
      filters.mostrarRecetas,
      filters.proveedorId,
      filters.searchText,
      !!filters.soloItemsConPLU,
      filtrosAtributos,
    )
  }

  const handleAtributoKeyDown = (event, campo, valorActual) => {
    if (event.key === "Enter") {
      event.preventDefault()
      // Asegurar que el valor actual esté sincronizado antes de aplicar filtros
      setFiltrosAtributos((prev) => {
        const nuevosFiltros = { ...prev, [campo]: valorActual }
        // Usar setTimeout para asegurar que el estado se actualice antes de buscar
        setTimeout(() => {
          fetchData(
            filters.ubicacionId,
            filters.itemId,
            filters.precio,
            filters.soloStockBajo,
            filters.mostrarUltimosCreados,
            filters.mostrarRecetas,
            filters.proveedorId,
            filters.searchText,
            !!filters.soloItemsConPLU,
            nuevosFiltros,
          )
        }, 0)
        return nuevosFiltros
      })
    }
  }

  const handleLimpiarFiltrosAtributos = () => {
    setFiltrosAtributos({})
    fetchData(
      filters.ubicacionId,
      filters.itemId,
      filters.precio,
      filters.soloStockBajo,
      filters.mostrarUltimosCreados,
      filters.mostrarRecetas,
      filters.proveedorId,
      filters.searchText,
      !!filters.soloItemsConPLU,
      {},
    )
  }

  const cantidadFiltrosAtributosActivos = Object.values(filtrosAtributos).filter(
    (valor) => valor && valor.trim() !== "",
  ).length

  const contarFiltrosActivos = () => {
    let count = 0
    if (filtroRecetas) count++
    if (filtroUltimosCreados) count++
    if (filtroStockBajo) count++
    if (soloItemsConPLU) count++
    if (cantidadFiltrosAtributosActivos > 0) count += cantidadFiltrosAtributosActivos
    if (modoEliminacion) count++ // Contar modoEliminacion directamente
    return count
  }

  // Funciones del escÃ¡ner QR/Barras
  const handleToggleScanner = () => {
    if (isScannerActive) {
      handleCloseScanner()
    } else {
      setIsScannerActive(true)
      setScannerError(null)
      setScannedCode(null)
      setIsScannedItemModalOpen(false)
      setScannedItemData(null)
    }
  }

  const handleCloseScanner = () => {
    setIsScannerActive(false)
    setIsScanning(false)
    setScannerError(null)
    setScannedCode(null)
    setScannerInitialized(false)
    if (scannerReader) {
      try {
        scannerReader.reset()
      } catch (error) {
        console.warn('Error al resetear scanner:', error)
      }
      setScannerReader(null)
    }
  }

  const initializeScanner = async () => {
    if (scannerInitialized) return // Evitar múltiples inicializaciones
    
    try {
      const { BrowserMultiFormatReader } = await import('@zxing/browser')
      const reader = new BrowserMultiFormatReader()
      setScannerReader(reader)
      setScannerInitialized(true)
      
      const videoElement = document.getElementById('scanner-video')
      if (!videoElement) {
        throw new Error('Elemento de video no encontrado')
      }

      await reader.decodeFromVideoDevice(undefined, videoElement, (result, err) => {
        if (result) {
          handleCodeDetected(result.getText())
        }
        if (err && !err.message.includes('No MultiFormat Readers')) {
          console.warn('Error de escaneo:', err)
        }
      })
    } catch (error) {
      console.error('Error al inicializar escÃ¡ner:', error)
      setScannerError('Error al acceder a la cámara. Verifique los permisos.')
    }
  }

  const handleCodeDetected = async (code) => {
    if (isScanning) return // Evitar múltiples escaneos simultáneos
    
    setIsScanning(true)
    setScannedCode(code)
    
    try {
      // Extraer el ID del código escaneado
      let codeToSearch = code
      
      // Si el cÃ³digo es un JSON, extraer el ID
      if (typeof code === 'string' && code.startsWith('{')) {
        try {
          const parsedCode = JSON.parse(code)
          if (parsedCode.id) {
            codeToSearch = parsedCode.id
            console.log('Código JSON detectado:', parsedCode, 'ID extraído:', codeToSearch)
          }
        } catch (parseError) {
          console.warn('Error al parsear código JSON:', parseError)
          // Si no se puede parsear, usar el código original
        }
      }
      
      console.log('Buscando código:', codeToSearch)
      
      // Buscar item por código scanner
      const response = await getItemAndItemUbicacion(
        1, // page
        100, // limit
        null, // ubicacionId
        null, // itemId  
        null, // precio
        false, // soloStockBajo
        false, // mostrarUltimosCreados
        false, // mostrarRecetas
        null, // proveedorId
        codeToSearch, // searchText - buscar por código scanner extraído
        false, // soloItemsConPLU
        {} // filtrosAtributos
      )
      
      if (response && response.data && response.data.length > 0) {
        // Preferir coincidencia exacta por codigoScanner
        const exactMatch = response.data.find(r => r.codigoScanner && String(r.codigoScanner).trim() === String(codeToSearch).trim())
        const foundItem = exactMatch || response.data[0]
        console.log('Item encontrado:', foundItem)

        // Cerrar escáner primero para evitar bucles
        handleCloseScanner()

        // Determinar itemId correcto (idItem si existe, caso contrario id)
        const resolvedItemId = foundItem.idItem ?? foundItem.id
        const resolvedBarcode = foundItem.codigoScanner || codeToSearch

        setScannedItemData({
          item: foundItem,
          itemId: resolvedItemId,
          barcode: resolvedBarcode,
          originalCode: code,
          searchText: codeToSearch
        })
        setIsScannedItemModalOpen(true)

      } else {
        // Item no encontrado
        console.log('Item no encontrado para código:', codeToSearch)
        setScannerError(`Código "${codeToSearch}" no encontrado en el inventario`)
        setTimeout(() => setScannerError(null), 3000)
      }
    } catch (error) {
      console.error('Error al buscar item:', error)
      setScannerError('Error al buscar el código en el inventario')
      setTimeout(() => setScannerError(null), 3000)
    } finally {
      setIsScanning(false)
    }
  }


  const handleFilterScannedItem = () => {
    if (!scannedItemData) return
    setFilters((prev) => ({
      ...prev,
      itemId: scannedItemData.itemId,
      searchText: scannedItemData.barcode || ""
    }))
    setPage(1)
    setIsScannedItemModalOpen(false)
    setScannedItemData(null)
  }

  const handleCloseScannedItemModal = () => {
    setIsScannedItemModalOpen(false)
    setScannedItemData(null)
  }

  const handleResumeScanner = () => {
    setIsScannedItemModalOpen(false)
    setScannedItemData(null)
    setScannerError(null)
    setScannedCode(null)
    setIsScanning(false)
    setScannerInitialized(false)
    setTimeout(() => {
      setIsScannerActive(true)
    }, 150)
  }

  const deleteCheckboxColumn = modoEliminacion
    ? [
        {
          field: "selectDelete",
          headerName: "Eliminar",
          width: 90,
          headerAlign: "center",
          sortable: false,
          renderHeader: () => (
            <Checkbox
              checked={
                itemsSeleccionadosParaEliminar.length === itemAndItemUbicacion.length && itemAndItemUbicacion.length > 0
              }
              indeterminate={
                itemsSeleccionadosParaEliminar.length > 0 &&
                itemsSeleccionadosParaEliminar.length < itemAndItemUbicacion.length
              }
              onChange={(e) => handleSelectAllForDelete(e.target.checked)}
              size="small"
              color="error"
            />
          ),
          renderCell: (params) => (
            <Checkbox
              checked={itemsSeleccionadosParaEliminar.includes(params.row.idItem)}
              onChange={(e) => handleSelectItemForDelete(params.row.idItem, e.target.checked)}
              size="small"
              color="error"
            />
          ),
        },
      ]
    : []

  const staticColumnsBefore = [
    {
      field: "codigo",
      headerName: "Código",
      width: 130,
      headerAlign: "center",
      align: "right",
      renderCell: (params) => (
        <Chip
          label={params.value}
          size="small"
          variant="outlined"
          sx={{
            fontWeight: 500,
            borderColor: "rgb(244, 147, 14)",
            color: "rgb(244, 147, 14)",
          }}
        />
      ),
    },
    {
      field: "codigoScanner",
      headerName: "Código de barras",
      width: 130,
      headerAlign: "center",
      renderCell: (params) => (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <BarcodeIcon fontSize="small" sx={{ color: alpha("#5b5b5f", 0.7) }} />
          <Typography variant="body2">{params.value}</Typography>
        </Box>
      ),
    },
    {
      field: "descripcion",
      headerName: "Item",
      width: 300,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <InventoryIcon fontSize="small" sx={{ color: alpha("#5b5b5f", 0.7) }} />
            <Typography
              variant="body2"
              sx={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {params.value}
            </Typography>
          </Box>
        </Tooltip>
      ),
    },
  ]

  const staticColumnsAfter = [
    {
      field: "ubicacion",
      headerName: "Ubicación",
      width: 130,
      headerAlign: "center",
      align: "right",
      renderCell: (params) => (
        <Box sx={{ display: "flex", alignItems: "right", gap: 1 }}>
          <LocationOnIcon fontSize="small" sx={{ color: alpha("#5b5b5f", 0.7) }} />
          <Typography variant="body2">{params.value}</Typography>
        </Box>
      ),
    },
    {
      field: "inventario",
      headerName: "Stock",
      width: 130,
      headerAlign: "center",
      align: "right",
      renderCell: (params) => (
        <Chip
          label={formatStock(params.value)}
          size="small"
          color="warning"
          sx={{
            fontWeight: "bold",
            backgroundColor: alpha("#3182ce", 0.1),
            color: "#3182ce",
            border: `1px solid ${alpha("#3182ce", 0.3)}`,
          }}
        />
      ),
    },
    {
      field: "stockMinimo",
      headerName: "Stock Mínimo",
      width: 130,
      headerAlign: "center",
      align: "right",
      renderCell: (params) => (
        <Chip
          label={params.value}
          size="small"
          color="warning"
          sx={{
            fontWeight: "bold",
            backgroundColor: alpha("#f4b10e", 0.1),
            color: "#f4b10e",
            border: `1px solid ${alpha("#f4b10e", 0.3)}`,
          }}
        />
      ),
    },
    {
      field: "updatedAt",
      headerName: "Última Actualización",
      width: 150,
      headerAlign: "center",
      align: "right",
      sortComparator: compareDateValues,
      renderCell: (params) => {
        if (!params.value) return "-"
        try {
          // Formatear usando el parámetro global formatoFechas
          const date = new Date(params.value)
          return new Intl.DateTimeFormat("es-AR", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit"
          }).format(date)
        } catch (error) {
          console.error("Error formateando fecha:", error)
          return params.value
        }
      },
    },
    {
      field: "alertaStock",
      headerName: "Alerta Stock",
      width: 130,
      headerAlign: "center",
      align: "right",
      sortable: false,
      renderCell: (params) =>
        params.row.lowStock ? (
          <Tooltip title="Stock por debajo del mínimo">
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
              <WarningIcon style={{ color: "#ff9800" }} fontSize="small" />
              <Typography variant="caption" sx={{ color: "#ff9800", fontWeight: 600 }}>
                Stock bajo
              </Typography>
            </Box>
          </Tooltip>
        ) : (
          <Chip
            label="OK"
            size="small"
            sx={{
              backgroundColor: alpha("#4caf50", 0.1),
              color: "#4caf50",
              fontWeight: 600,
              border: `1px solid ${alpha("#4caf50", 0.3)}`,
            }}
          />
        ),
    },
    {
      field: "action",
      headerName: "Editar",
      width: 100,
      headerAlign: "center",
      align: "right",
      sortable: false,
      renderCell: (params) => (
        <IconButton
          className="colorGeneralParaIconos"
          onClick={() => {
            setItemEditable(params.row)
            setOpenModal(true)
          }}
          sx={{
            color: theme.palette.primary.main,
            "&:hover": {
              backgroundColor: alpha(theme.palette.primary.main, 0.2),
            },
            transition: "background-color 0.2s",
          }}
        >
          <EditIcon fontSize="small" />
        </IconButton>
      ),
    },
    ...(filters.proveedorId
      ? [
          {
            field: "select",
            headerName: "Comprar",
            width: 100,
            headerAlign: "center",
            sortable: false,
            renderHeader: () => (
              <Checkbox checked={selectAll} onChange={(e) => handleSelectAll(e.target.checked)} size="small" />
            ),
            renderCell: (params) => (
              <Checkbox
                checked={selectedItems.includes(params.row.id)}
                onChange={(e) => handleSelectItem(params.row.id, e.target.checked)}
                size="small"
              />
            ),
          },
        ]
      : []),
  ]

  const dynamicColumns = itemAtributoNoEliminados
    .filter((attr) => !attr.eliminado)
    .map((attr, index) => {
      const field = `itemDatoAtributo${index + 1}`

      return {
        field,
        headerName: attr.descripcion,
        width: 150,
        headerAlign: "center",
        align: "right",
        valueGetter: (value, row) => getAttributeValue(row, field),
        sortComparator: compareTextValues,
        renderCell: (params) => <Typography variant="body2">{params.value || "-"}</Typography>,
      }
    })

  const precioProveedorColumn = filters.proveedorId
    ? [
        {
          field: "precioProveedor",
          headerName: "Precio Proveedor",
          width: 130,
          headerAlign: "center",
          align: "right",
          sortable: false,
          renderCell: (params) => (
            <Chip
              label={params.value ? `$${params.value.toLocaleString("es-AR")}` : "N/A"}
              size="small"
              variant="outlined"
              sx={{
                fontWeight: 500,
                borderColor: params.value ? "rgb(76, 175, 80)" : "rgb(158, 158, 158)",
                color: params.value ? "rgb(76, 175, 80)" : "rgb(158, 158, 158)",
              }}
            />
          ),
        },
      ]
    : []

  const columns = [
    ...deleteCheckboxColumn,
    ...staticColumnsBefore,
    ...dynamicColumns,
    ...precioProveedorColumn,
    ...staticColumnsAfter,
  ]

  const fetchData = async (
    ubicacionId,
    itemId,
    precio,
    soloStockBajo,
    mostrarUltimosCreados,
    mostrarRecetas,
    proveedorId,
    searchText = null,
    soloConPLU = false,
    atributosFilters = {},
    sortFieldOverride = currentSortField,
    sortDirectionOverride = currentSortDirection,
  ) => {
    try {
      await getItemAtributoNoEliminados()
      const data = await getItemAndItemUbicacion(
        page,
        100,
        ubicacionId,
        itemId,
        precio,
        soloStockBajo,
        mostrarUltimosCreados,
        mostrarRecetas,
        proveedorId,
        searchText,
        soloConPLU,
        atributosFilters,
        sortFieldOverride,
        sortDirectionOverride,
      )
      if (data) {
        console.log(data.data)
        setItemAndItemUbicacion(data.data)
        setTotalPages(data.totalPages)
        setTotalCount(data.total)
      }
    } catch (error) {
      console.error("Error fetching inventory data:", error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    // 🔧 FIX: Siempre pasar los valores de filtros de toggle desde sus estados locales
    // No depender solo del objeto filters para evitar desincronización
    fetchData(
      filters.ubicacionId || null,
      filters.itemId || null,
      filters.precio || null,
      filtroStockBajo,              // ✅ Usar estado local en lugar de filters.soloStockBajo
      filtroUltimosCreados,         // ✅ Usar estado local en lugar de filters.mostrarUltimosCreados
      filtroRecetas,                // ✅ Usar estado local en lugar de filters.mostrarRecetas
      filters.proveedorId || null,
      filters.searchText || null,
      soloItemsConPLU,              // ✅ Usar estado local en lugar de filters.soloItemsConPLU
      filtrosAtributos,
    )
  }, [page, alignment, filters, sortModel, filtroStockBajo, filtroUltimosCreados, filtroRecetas, soloItemsConPLU, filtrosAtributos])

  const handleChange = (_, newAlignment) => {
    if (newAlignment) setAlignment(newAlignment)
  }

  const handleOpenModal = async (transaccionRow) => {
    console.log(transaccionRow)
    setItemEditable(transaccionRow)
    setOpenModal(true)
  }

  const handleCloseModal = () => {
    setOpenModal(false)
    fetchData(
      filters.ubicacionId,
      filters.itemId,
      filters.precio,
      filtroStockBajo,              // ✅ Usar estado local
      filtroUltimosCreados,         // ✅ Usar estado local
      filtroRecetas,                // ✅ Usar estado local
      filters.proveedorId,
      filters.searchText,
      soloItemsConPLU,              // ✅ Usar estado local
      filtrosAtributos,
    )
  }

  const handleFilterSearch = (newFilters) => {
    setFilters((prev) => ({
      ...prev,
      ...newFilters,
      // 🔧 FIX: Preservar filtros de toggle si no vienen en newFilters
      soloItemsConPLU:
        typeof newFilters.soloItemsConPLU === "boolean" ? newFilters.soloItemsConPLU : prev.soloItemsConPLU,
      mostrarRecetas:
        typeof newFilters.mostrarRecetas === "boolean" ? newFilters.mostrarRecetas : prev.mostrarRecetas,
      mostrarUltimosCreados:
        typeof newFilters.mostrarUltimosCreados === "boolean" ? newFilters.mostrarUltimosCreados : prev.mostrarUltimosCreados,
      soloStockBajo:
        typeof newFilters.soloStockBajo === "boolean" ? newFilters.soloStockBajo : prev.soloStockBajo,
    }))
    setPage(1)
    setSelectedItems([])
    setSelectAll(false)
    setUbicacionSeleccionada(newFilters.ubicacionId || null)
    if (typeof newFilters.soloItemsConPLU === "boolean") {
      setSoloItemsConPLU(newFilters.soloItemsConPLU)
    }
    setItemsSeleccionadosParaEliminar([])
    setModoEliminacion(false)
  }

  const handleAlignmentChange = (_, newAlignment) => {
    if (newAlignment) setAlignment(newAlignment)
  }

  const handleRefresh = () => {
    setFilters({})
    setPage(1)
    setSortModel([])
    setSelectedItems([])
    setSelectAll(false)
    setFiltrosAtributos({})
    setFiltroRecetas(false)
    setFiltroUltimosCreados(false)
    setFiltroStockBajo(false)
    setSoloItemsConPLU(false)
    setModoEliminacion(false)
    setItemsSeleccionadosParaEliminar([])
    fetchData(null, null, null, null, null, null, null, null, false, {}, null, null)
  }

  const handleSelectItem = (itemId, isSelected) => {
    if (isSelected) {
      setSelectedItems((prev) => [...prev, itemId])
      if (selectedItems.length + 1 === itemAndItemUbicacion.length) {
        setSelectAll(true)
      }
    } else {
      setSelectedItems((prev) => prev.filter((id) => id !== itemId))
      setSelectAll(false)
    }
  }

  const handleSelectAll = (isSelected) => {
    if (isSelected) {
      const allItemIds = itemAndItemUbicacion.map((item) => item.id)
      setSelectedItems(allItemIds)
      setSelectAll(true)
    } else {
      setSelectedItems([])
      setSelectAll(false)
    }
  }

  const handleGenerateCompra = () => {
    const selectedItemsData = itemAndItemUbicacion.filter((item) => selectedItems.includes(item.id))

    const dataForCompra = {
      selectedItems: selectedItemsData,
      proveedor: filters.proveedorId
        ? {
            id: filters.proveedorId,
          }
        : null,
      ubicacion: filters.ubicacionId
        ? {
            id: filters.ubicacionId,
          }
        : null,
    }

    console.log("Abriendo modal de compra con datos:", dataForCompra)

    setCompraData(dataForCompra)
    setOpenCompraModal(true)
  }

  const handleCloseCompraModal = () => {
    setOpenCompraModal(false)
    setCompraData(null)
    setSelectedItems([])
    setSelectAll(false)
  }

  const handleSelectItemForDelete = (itemId, isSelected) => {
    if (isSelected) {
      setItemsSeleccionadosParaEliminar((prev) => [...prev, itemId])
    } else {
      setItemsSeleccionadosParaEliminar((prev) => prev.filter((id) => id !== itemId))
    }
  }

  const handleSelectAllForDelete = (isSelected) => {
    if (isSelected) {
      const allItemIds = itemAndItemUbicacion.map((item) => item.idItem) // Usar idItem para la selección masiva
      setItemsSeleccionadosParaEliminar(allItemIds)
    } else {
      setItemsSeleccionadosParaEliminar([])
    }
  }

  const handleOpenDeleteModal = () => {
    if (itemsSeleccionadosParaEliminar.length === 0) {
      alert("Debe seleccionar al menos un item para eliminar")
      return
    }
    setOpenConfirmDeleteModal(true)
  }

  const handleConfirmDelete = async () => {
    try {
      setLoading(true)

      const result = await bulkDeleteItems(
        itemsSeleccionadosParaEliminar,
        filters.ubicacionId || null, // Pasar ubicacionId para eliminación específica
      )

      console.log("✅ Eliminación exitosa:", result)

      setOpenConfirmDeleteModal(false)
      setItemsSeleccionadosParaEliminar([])
      setModoEliminacion(false)

      await fetchData(
        filters.ubicacionId,
        filters.itemId,
        filters.precio,
        filters.soloStockBajo,
        filters.mostrarUltimosCreados,
        filters.mostrarRecetas,
        filters.proveedorId,
        filters.searchText,
        !!filters.soloItemsConPLU,
        filtrosAtributos,
      )

      alert(`✅ Se eliminaron ${result.eliminados || itemsSeleccionadosParaEliminar.length} item(s) exitosamente`)
    } catch (error) {
      console.error("❌ Error al eliminar items:", error)
      alert("Error al eliminar items: " + (error.response?.data?.message || error.message))
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return <SpinnerLading />
  }

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          minHeight: 0,
          width: "100%",
          maxWidth: "100%",
          overflow: "hidden",
          position: "relative",
          "&::-webkit-scrollbar": {
            display: "none",
          },
          scrollbarWidth: "none", // Firefox
          msOverflowStyle: "none", // IE and Edge
        }}
      >
        <Box
          sx={{
            flexShrink: 0,
            backgroundColor: "#f5f5f5",
            boxShadow: "0 2px 10px rgba(0,0,0,0.05)",
            borderRadius: "8px 8px 0 0",
          }}
        >
          {/* Filtros básicos */}
          <Box sx={{ p: 2 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                alignItems: { xs: "stretch", md: "center" },
                gap: 2,
              }}
            >
              <Box sx={{ flex: 1 }}>
                <BuscadorItemsUbicaciones onSearch={handleFilterSearch} vieneDe="inventario" />
              </Box>

              <Tooltip title={filterDrawerOpen ? "Ocultar filtros avanzados" : "Mostrar más filtros"}>
                <Badge badgeContent={contarFiltrosActivos()} color="primary">
                  <IconButton
                    onClick={toggleFilterDrawer}
                    size="medium"
                    sx={{
                      alignSelf: { xs: "flex-end", md: "center" },
                      color: theme.palette.primary.main,
                      border: `1px solid ${alpha(theme.palette.primary.main, filterDrawerOpen ? 0.5 : 0.3)}`,
                      bgcolor: filterDrawerOpen ? alpha(theme.palette.primary.main, 0.1) : "transparent",
                      transition: "background-color 0.2s ease",
                      "&:hover": {
                        bgcolor: alpha(theme.palette.primary.main, 0.15),
                      },
                    }}
                  >
                    <TuneIcon />
                  </IconButton>
                </Badge>
              </Tooltip>
            </Box>
          </Box>

          {(mostrarFiltroAtributos || mostrarFiltroPLU) && (
            <Box
              sx={{
                p: 2,
                pt: 0,
                display: "flex",
                flexDirection: "column",
                gap: 2,
                borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
              }}
            >
              {mostrarFiltroAtributos && itemAtributoNoEliminados && itemAtributoNoEliminados.length > 0 && (
                <Paper
                  elevation={2}
                  sx={{
                    p: 2,
                    backgroundColor: alpha(theme.palette.primary.main, 0.02),
                    border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
                  }}
                >
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: theme.palette.primary.main }}>
                      Filtros por Atributos
                    </Typography>
                    <IconButton size="small" onClick={() => setMostrarFiltroAtributos(false)}>
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </Box>

                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "repeat(3, 1fr)", lg: "repeat(4, 1fr)" },
                      gap: 2,
                    }}
                  >
                    {mapearAtributosACampos().map((atributo) => (
                      <Autocomplete
                        key={atributo.campo}
                        freeSolo
                        options={sugerenciasAtributos[atributo.campo] || []}
                        value={filtrosAtributos[atributo.campo] || ""}
                        onInputChange={(event, newValue) => {
                          handleAtributoFilterChange(atributo.campo, newValue)
                          // Cargar sugerencias cuando el usuario escribe (mínimo 2 caracteres)
                          if (newValue && newValue.length >= 2) {
                            cargarSugerenciasAtributo(atributo.campo, newValue)
                          }
                        }}
                        onChange={(event, newValue) => {
                          handleAtributoFilterChange(atributo.campo, newValue || "")
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={atributo.descripcion}
                            size="small"
                            placeholder="Buscar..."
                            onKeyDown={(event) => {
                              // Obtener el valor actual del input directamente
                              const valorActual = event.target.value || ""
                              handleAtributoKeyDown(event, atributo.campo, valorActual)
                            }}
                            InputProps={{
                              ...params.InputProps,
                              startAdornment: (
                                <>
                                  <InputAdornment position="start">
                                    <SearchIcon fontSize="small" color="action" />
                                  </InputAdornment>
                                  {params.InputProps.startAdornment}
                                </>
                              ),
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                backgroundColor: filtrosAtributos[atributo.campo]
                                  ? alpha(theme.palette.primary.main, 0.05)
                                  : "white",
                              },
                            }}
                          />
                        )}
                      />
                    ))}
                  </Box>

                  {cantidadFiltrosAtributosActivos > 0 && (
                    <Box sx={{ display: "flex", gap: 1, mt: 2, justifyContent: "flex-end" }}>
                      <Button
                        size="small"
                        variant="contained"
                        color="primary"
                        onClick={handleAplicarFiltrosAtributos}
                        sx={{ textTransform: "none" }}
                      >
                        Aplicar Filtros
                      </Button>
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={handleLimpiarFiltrosAtributos}
                        sx={{ textTransform: "none" }}
                      >
                        Limpiar
                      </Button>
                    </Box>
                  )}
                </Paper>
              )}

              {mostrarFiltroPLU && showPluExport && (
                <Paper
                  elevation={2}
                  sx={{
                    p: 2,
                    backgroundColor: alpha(theme.palette.success.main, 0.02),
                    border: `1px solid ${alpha(theme.palette.success.main, 0.2)}`,
                  }}
                >
                  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: theme.palette.success.main }}>
                      Exportar PLUs de Balanza
                    </Typography>
                    <IconButton size="small" onClick={() => setMostrarFiltroPLU(false)}>
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  </Box>

                  <Box sx={{ display: "flex", flexDirection: "column", gap: 1, maxWidth: 400 }}>
                    <Button
                      onClick={handleExportarPLUsBalanza}
                      variant="contained"
                      size="medium"
                      startIcon={<FileDownloadIcon />}
                      disabled={!isExportButtonEnabled()}
                      sx={{
                        backgroundColor: isExportButtonEnabled() ? "success.main" : "grey.400",
                        color: "white",
                        textTransform: "none",
                        "&:hover": {
                          backgroundColor: isExportButtonEnabled() ? "success.dark" : "grey.400",
                        },
                      }}
                    >
                      Exportar PLUs
                    </Button>

                    {!isExportButtonEnabled() && (
                      <Typography variant="caption" color="text.secondary">
                        {!ubicacionSeleccionada
                          ? "⚠️ Seleccione una ubicación antes de exportar"
                          : !parametrosGlobales?.fabricanteBalanza
                            ? "⚠️ Fabricante de balanza no configurado"
                            : "✓ Listo para exportar"}
                      </Typography>
                    )}
                  </Box>
                </Paper>
              )}
            </Box>
          )}
        </Box>

        <Drawer
          anchor="right"
          open={filterDrawerOpen}
          onClose={toggleFilterDrawer}
          variant="persistent"
          sx={{
            "& .MuiDrawer-paper": {
              width: 80,
              top: 0,
              height: "100%",
              maxHeight: "100%",
              backgroundColor: alpha(theme.palette.background.paper, 0.98),
              borderLeft: `2px solid ${alpha(theme.palette.primary.main, 0.2)}`,
              boxShadow: "-4px 0 20px rgba(0,0,0,0.1)",
              zIndex: 1000,
              overflowX: "hidden",
            },
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", height: "100%", p: 1 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mb: 2,
                pb: 1,
                borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
              }}
            >
              <IconButton size="small" onClick={toggleFilterDrawer}>
                <ChevronRightIcon fontSize="small" />
              </IconButton>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 1, mb: 2 }}>
              {/* Iconos de Filtros y Eliminar - Arriba de todo */}
              <Tooltip title="Filtrar por atributos" placement="left">
                <IconButton
                  onClick={() => setMostrarFiltroAtributos(!mostrarFiltroAtributos)}
                  sx={{
                    color: mostrarFiltroAtributos ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    "& svg": {
                      color: mostrarFiltroAtributos ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    },
                  }}
                >
                  <Badge badgeContent={cantidadFiltrosAtributosActivos} color="primary">
                    <FilterAltIcon />
                  </Badge>
                </IconButton>
              </Tooltip>

              <Tooltip title="Modo eliminación" placement="left">
                <IconButton
                  onClick={() => {
                    const newValue = !modoEliminacion
                    setModoEliminacion(newValue)
                    if (!newValue) {
                      setItemsSeleccionadosParaEliminar([])
                    }
                  }}
                  sx={{
                    color: modoEliminacion ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    "& svg": {
                      color: modoEliminacion ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    },
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>

              <Divider sx={{ my: 1 }} />

              <Tooltip title="Mostrar recetas" placement="left">
                <IconButton
                  onClick={handleToggleFiltroRecetas}
                  sx={{
                    color: filtroRecetas ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    "& svg": {
                      color: filtroRecetas ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    },
                  }}
                >
                  <RestaurantIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="Últimos creados" placement="left">
                <IconButton
                  onClick={handleToggleFiltroUltimosCreados}
                  sx={{
                    color: filtroUltimosCreados ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    "& svg": {
                      color: filtroUltimosCreados ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    },
                  }}
                >
                  <NewReleasesIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="Stock bajo" placement="left">
                <IconButton
                  onClick={handleToggleFiltroStockBajo}
                  sx={{
                    color: filtroStockBajo ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    "& svg": {
                      color: filtroStockBajo ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    },
                  }}
                >
                  <WarningIcon />
                </IconButton>
              </Tooltip>

              {showPluExport && (
                <Tooltip title="Solo items con PLU" placement="left">
                  <IconButton
                    onClick={handleToggleFiltroPLU}
                    sx={{
                      color: soloItemsConPLU ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                      "& svg": {
                        color: soloItemsConPLU ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                      },
                    }}
                  >
                    <FormatListNumberedIcon />
                  </IconButton>
                </Tooltip>
              )}

              <Tooltip title="Escanear código QR/Barras" placement="left">
                <IconButton
                  onClick={handleToggleScanner}
                  sx={{
                    color: isScannerActive ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    "& svg": {
                      color: isScannerActive ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                    },
                  }}
                >
                  <QrCodeScannerIcon />
                </IconButton>
              </Tooltip>

              {showPluExport && (
                <Tooltip title="Exportar PLUs balanza" placement="left">
                  <IconButton
                    onClick={() => setMostrarFiltroPLU(!mostrarFiltroPLU)}
                    sx={{
                      color: mostrarFiltroPLU ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                      "& svg": {
                        color: mostrarFiltroPLU ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                      },
                    }}
                  >
                    <FileDownloadIcon />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          </Box>
        </Drawer>

        <Box 
          sx={{ 
            flex: 1, 
            minHeight: 0,
            minWidth: 0,
            overflow: "hidden",
            position: "relative",
            "&::-webkit-scrollbar": {
              display: "none",
            },
            scrollbarWidth: "none", // Firefox
            msOverflowStyle: "none", // IE and Edge
          }}
        >
          <Paper
            sx={{
              height: "100%",
              width: "100%",
              minHeight: 0,
              minWidth: 0,
              boxShadow: "none",
              border: "1px solid rgba(0,0,0,0.08)",
              borderTop: "none",
              overflow: "hidden",
              "&::-webkit-scrollbar": {
                display: "none",
              },
              scrollbarWidth: "none", // Firefox
              msOverflowStyle: "none", // IE and Edge
            }}
          >
            <DataGrid
              className="tablaVentasDataGrid"
              rows={itemAndItemUbicacion}
              columns={columns}
              getRowId={(row) => row.id}
              sortingMode="server"
              sortModel={sortModel}
              onSortModelChange={(newSortModel) => {
                setSortModel(newSortModel)
                setPage(1)
              }}
              pageSizeOptions={[5, 10]}
              pagination
              getRowHeight={() => 35}
              headerHeight={35}
              paginationMode="server"
              pageSize={100}
              sx={{
                width: "100%",
                height: "100%",
                border: 0,
                overflow: "hidden",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                scrollbarWidth: "none", // Firefox
                msOverflowStyle: "none", // IE and Edge
                "& .MuiDataGrid-footerContainer": {
                  display: "none !important",
                },
                "& .MuiDataGrid-columnHeaders": {
                  backgroundColor: "#5b5b5f",
                  color: "white",
                  borderBottom: "2px solid #333",
                  height: "45px !important",
                  minHeight: "45px !important",
                  maxHeight: "45px !important",
                },
                "& .MuiDataGrid-columnHeader": {
                  height: "45px !important",
                  minHeight: "45px !important",
                  maxHeight: "45px !important",
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  color: "white !important",
                  lineHeight: "45px !important",
                },
                "& .MuiDataGrid-columnHeaderTitle .MuiDataGrid-menuIconButton": {
                  color: "white !important",
                },
                "& .MuiDataGrid-menuIconButton": {
                  color: "rgb(244, 177, 14) !important",
                },
                "& .MuiInputBase-root": {
                  color: "rgb(244, 177, 14) !important",
                },
                "& .MuiTablePagination-root": {
                  color: "black !important",
                },
                "& .MuiSelect-icon": {
                  color: "rgb(244, 177, 14) !important",
                },
                "& .MuiDataGrid-cell": {
                  borderBottom: "1px solid #ccc",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                },
                "& .MuiDataGrid-row": {
                  "&:nth-of-type(even)": {
                    backgroundColor: "#F7F7F7",
                  },
                  "&:hover": {
                    backgroundColor: "#E3EAFD",
                    transition: "background 0.3s ease",
                  },
                },
                "& .row-devolucion": {
                  backgroundColor: alpha("#9e9e9e !important", 0.05),
                  "&:hover": {
                    backgroundColor: alpha("#9e9e9e !important", 0.1),
                  },
                },
                "& .MuiDataGrid-virtualScroller": {
                  lineHeight: "none !important",
                  height: "100% !important",
                  maxHeight: "100% !important",
                  overflowX: "hidden !important",
                  overflowY: "auto !important",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                    height: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: "#888",
                    borderRadius: "10px",
                  },
                  "&::-webkit-scrollbar-track": {
                    backgroundColor: "#f1f1f1",
                    borderRadius: "10px",
                  },
                },
                "& .MuiDataGrid-footerContainer": {
                  position: "sticky",
                  bottom: 0,
                  backgroundColor: "#ffffff",
                  borderTop: "1px solid #ddd",
                  zIndex: 10,
                },
              }}
              components={{
                Pagination: () => null,
              }}
            />
          </Paper>
        </Box>

        <Box
          sx={{
            flexShrink: 0,
            backgroundColor: "#f5f5f5",
            borderRadius: "0 0 8px 8px",
            borderTop: "1px solid rgba(0,0,0,0.08)",
            padding: "0px",
            paddingBottom: "10px",
            zIndex: 1200,
          }}
        >
          <CustomPagination
            currentPage={page}
            totalPages={totalPages}
            totalCount={totalCount}
            vieneDe={"inventaryComponent"}
            onPageChange={(newPage) => setPage(newPage)}
          />
        </Box>

        {modoEliminacion && itemsSeleccionadosParaEliminar.length > 0 && (
          <Box
            sx={{
              mt: 2,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: 2,
              backgroundColor: alpha(theme.palette.error.main, 0.08),
              borderRadius: 2,
              border: `2px solid ${theme.palette.error.main}`,
              animation: "pulse 2s ease-in-out infinite",
              "@keyframes pulse": {
                "0%, 100%": { borderColor: theme.palette.error.main },
                "50%": { borderColor: alpha(theme.palette.error.main, 0.5) },
              },
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <DeleteIcon color="error" />
              <Box>
                <Typography variant="body1" sx={{ fontWeight: 700, color: "error.main" }}>
                  {itemsSeleccionadosParaEliminar.length} item(s) seleccionado(s) para eliminar
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {hayFiltroUbicacion
                    ? `Se eliminará solo de la ubicación filtrada`
                    : "Se eliminarán los items completos y todas sus ubicaciones"}
                </Typography>
              </Box>
            </Box>

            <Box sx={{ display: "flex", gap: 1 }}>
              <Button
                variant="outlined"
                size="small"
                color="inherit"
                onClick={() => {
                  setItemsSeleccionadosParaEliminar([])
                }}
                sx={{ textTransform: "none" }}
              >
                Cancelar
              </Button>

              <Button
                variant="contained"
                size="small"
                color="error"
                startIcon={<DeleteIcon />}
                onClick={handleOpenDeleteModal}
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                  "&:hover": {
                    backgroundColor: theme.palette.error.dark,
                  },
                }}
              >
                Eliminar ({itemsSeleccionadosParaEliminar.length})
              </Button>
            </Box>
          </Box>
        )}

        {filters.proveedorId && (
          <Box
            sx={{
              mt: 2,
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              p: 2,
              backgroundColor: alpha(theme.palette.primary.main, 0.05),
              borderRadius: 2,
              border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              <Typography variant="body2" sx={{ fontWeight: 600 }}>
                {selectedItems.length} items seleccionados
              </Typography>
              {selectedItems.length > 0 && (
                <Chip label={`${selectedItems.length} seleccionados`} size="small" color="primary" variant="filled" />
              )}
            </Box>

            <Box sx={{ display: "flex", gap: 1 }}>
              <Button
                variant="outlined"
                size="small"
                onClick={() => {
                  setSelectedItems([])
                  setSelectAll(false)
                }}
                disabled={selectedItems.length === 0}
                sx={{ textTransform: "none" }}
              >
                Limpiar Selección
              </Button>

              <Button
                variant="contained"
                size="small"
                onClick={handleGenerateCompra}
                disabled={selectedItems.length === 0}
                sx={{
                  textTransform: "none",
                  backgroundColor: theme.palette.success.main,
                  "&:hover": {
                    backgroundColor: theme.palette.success.dark,
                  },
                }}
              >
                Generar Compra ({selectedItems.length})
              </Button>
            </Box>
          </Box>
        )}

        <Modal
          open={openModal}
          onClose={handleCloseModal}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
          closeAfterTransition
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              width: { xs: "98%", sm: "96%", md: "94%", lg: "92%" },
              maxWidth: "1100px",
              height: "95vh",
              bgcolor: "background.paper",
              boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
              borderRadius: "12px",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
              position: "relative",
              animation: "fadeIn 0.3s ease-out",
              "@keyframes fadeIn": {
                from: { opacity: 0, transform: "translateY(-20px)" },
                to: { opacity: 1, transform: "translateY(0)" },
              },
            }}
          >
            <IconButton
              onClick={handleCloseModal}
              sx={{
                position: "absolute",
                top: 12,
                right: 12,
                zIndex: 10,
                color: "grey.500",
                backgroundColor: "rgba(0,0,0,0.05)",
                "&:hover": {
                  backgroundColor: "rgba(0,0,0,0.1)",
                },
                transition: "background-color 0.2s",
              }}
            >
              <CloseIcon />
            </IconButton>

            {openModal && (
              <Box
                sx={{
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                }}
              >
                <CreateItemComponentModal onClose={handleCloseModal} selectedItem={itemEditable} />
              </Box>
            )}
          </Box>
        </Modal>

        <Modal
          open={openCompraModal}
          onClose={handleCloseCompraModal}
          aria-labelledby="compra-modal-title"
          aria-describedby="compra-modal-description"
          closeAfterTransition
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 1,
          }}
        >
          <Box
            sx={{
              width: "95vw",
              height: "90vh",
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 24,
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                p: 2,
                borderBottom: "1px solid rgba(0,0,0,0.12)",
                backgroundColor: alpha(theme.palette.primary.main, 0.1),
              }}
            >
              <Typography variant="h6" component="h2" sx={{ fontWeight: 600 }}>
                Generar Compra - {selectedItems.length} items seleccionados
              </Typography>
              <IconButton onClick={handleCloseCompraModal} size="small">
                <CloseIcon />
              </IconButton>
            </Box>

            <Box sx={{ flex: 1, overflow: "auto", p: 2 }}>
              {compraData && (
                <GestionGenerarCompraComponent
                  preloadedData={compraData}
                  onClose={handleCloseCompraModal}
                  isModal={true}
                />
              )}
            </Box>
          </Box>
        </Modal>
        {/* START UPDATE */}
        <Modal
          open={openConfirmDeleteModal}
          onClose={() => setOpenConfirmDeleteModal(false)}
          aria-labelledby="confirm-delete-modal-title"
          aria-describedby="confirm-delete-modal-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "background.paper",
              boxShadow: 24,
              p: 4,
              borderRadius: 2,
              minWidth: { xs: "90%", sm: 500 },
              maxWidth: 600,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
              <WarningIcon color="error" sx={{ fontSize: 48 }} />
              <Typography id="confirm-delete-modal-title" variant="h6" component="h2" sx={{ fontWeight: 700 }}>
                ⚠️ Confirmar Eliminación
              </Typography>
            </Box>

            <Divider sx={{ mb: 2 }} />

            <Typography id="confirm-delete-modal-description" variant="body1" sx={{ mb: 2 }}>
              Está a punto de eliminar{" "}
              <strong style={{ color: theme.palette.error.main }}>{itemsSeleccionadosParaEliminar.length}</strong>{" "}
              item(s).
            </Typography>

            <Box
              sx={{
                p: 2,
                mb: 3,
                backgroundColor: alpha(theme.palette.error.main, 0.05),
                borderRadius: 1,
                border: `1px solid ${alpha(theme.palette.error.main, 0.2)}`,
              }}
            >
              <Typography variant="body2" color="text.secondary" sx={{ fontWeight: 600 }}>
                {hayFiltroUbicacion
                  ? `📍 Se eliminará la ubicación de estos items, no el item completo.`
                  : "🗑️ Se eliminarán estos items y TODAS sus ubicaciones de forma permanente (soft delete)."}
              </Typography>
            </Box>

            <Typography variant="body2" color="error" sx={{ mb: 3, fontStyle: "italic" }}>
              Esta acción no se puede deshacer fácilmente.
            </Typography>

            <Box sx={{ display: "flex", gap: 2, justifyContent: "flex-end" }}>
              <Button
                variant="outlined"
                onClick={() => setOpenConfirmDeleteModal(false)}
                sx={{ textTransform: "none" }}
              >
                Cancelar
              </Button>

              <Button
                variant="contained"
                color="error"
                onClick={handleConfirmDelete}
                startIcon={<DeleteIcon />}
                sx={{
                  textTransform: "none",
                  fontWeight: 600,
                }}
              >
                Confirmar Eliminación
              </Button>
            </Box>
          </Box>
        </Modal>
        {/* END UPDATE */}

        {/* Modal con detalle del item escaneado */}
        <Dialog
          open={isScannedItemModalOpen}
          onClose={handleCloseScannedItemModal}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 1
            }}
          >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <InventoryIcon />
              <Typography variant="h6">Item escaneado</Typography>
            </Box>
            <IconButton onClick={handleCloseScannedItemModal}>
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box>
              <Typography variant="subtitle2" color="text.secondary">
                Descripción
              </Typography>
              <Typography variant="body1" sx={{ fontWeight: 600 }}>
                {scannedItem?.descripcion || "Sin descripción"}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                gap: 2
              }}
            >
              <Box>
                <Typography variant="subtitle2" color="text.secondary">
                  Código
                </Typography>
                <Typography variant="body2">
                  {scannedItem?.codigo || "Sin información"}
                </Typography>
              </Box>
              <Box>
                <Typography variant="subtitle2" color="text.secondary">
                  Código de barras
                </Typography>
                <Typography variant="body2">
                  {scannedItemData?.barcode || "Sin información"}
                </Typography>
              </Box>
              <Box>
                <Typography variant="subtitle2" color="text.secondary">
                  Ubicación
                </Typography>
                <Typography variant="body2">
                  {scannedItem?.ubicacion || "Sin asignar"}
                </Typography>
              </Box>
              <Box>
                <Typography variant="subtitle2" color="text.secondary">
                  Stock
                </Typography>
                <Typography variant="body2">
                  {scannedItem?.inventario !== null && scannedItem?.inventario !== undefined ? formatStock(scannedItem.inventario) : "Sin información"}
                </Typography>
              </Box>
              <Box>
                <Typography variant="subtitle2" color="text.secondary">
                  Stock mínimo
                </Typography>
                <Typography variant="body2">
                  {typeof scannedItem?.stockMinimo === "number" ? scannedItem.stockMinimo : "Sin información"}
                </Typography>
              </Box>
              <Box>
                <Typography variant="subtitle2" color="text.secondary">
                  Precio proveedor
                </Typography>
                <Typography variant="body2">
                  {formatCurrency(scannedItem?.precioProveedor)}
                </Typography>
              </Box>
            </Box>
            <Box>
              <Typography variant="subtitle2" color="text.secondary">
                Atributos
              </Typography>
              {scannedItemAttributes.length > 0 ? (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
                  {scannedItemAttributes.map(([key, value]) => (
                    <Chip
                      key={key}
                      label={`${attributeLabels[key] || key}: ${value}`}
                      size="small"
                      variant="outlined"
                    />
                  ))}
                </Box>
              ) : (
                <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
                  Sin atributos configurados para este item.
                </Typography>
              )}
            </Box>
            {scannedItemData?.originalCode && scannedItemData?.originalCode !== scannedItemData?.barcode && (
              <Alert severity="info">
                Código original leído: <strong>{scannedItemData.originalCode}</strong>
              </Alert>
            )}
          </DialogContent>
          <DialogActions sx={{ p: 2 }}>
            <Button onClick={handleCloseScannedItemModal} startIcon={<CloseIcon />} sx={{ textTransform: 'none' }}>
              Cerrar
            </Button>
            <Box sx={{ flexGrow: 1 }} />
            <Button
              onClick={handleResumeScanner}
              startIcon={<CameraAltIcon />}
              variant="outlined"
              sx={{ textTransform: 'none' }}
            >
              Volver a la cámara
            </Button>
            <Button
              onClick={handleFilterScannedItem}
              startIcon={<FilterAltIcon />}
              variant="contained"
              disabled={!scannedItemData}
              sx={{ textTransform: 'none' }}
            >
              Filtrar item
            </Button>
          </DialogActions>
        </Dialog>
        {/* Modal del Escáner QR/Barras */}
        <Dialog
          open={isScannerActive}
          onClose={handleCloseScanner}
          maxWidth="md"
          fullWidth
          PaperProps={{
            sx: {
              backgroundColor: theme.palette.background.paper,
              borderRadius: 2,
            }
          }}
        >
          <DialogTitle sx={{ 
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: 'center',
            backgroundColor: theme.palette.primary.main,
            color: 'white',
            fontWeight: 600
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <QrCodeScannerIcon />
              <Typography variant="h6">Escanear Código QR/Barras</Typography>
            </Box>
            <IconButton 
              onClick={handleCloseScanner}
              sx={{ color: 'white' }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent sx={{ p: 0, position: 'relative' }}>
            {scannerError && (
              <Alert 
                severity="error" 
                sx={{ m: 2, mb: 0 }}
                onClose={() => setScannerError(null)}
              >
                {scannerError}
              </Alert>
            )}

            {scannedCode && (
              <Alert 
                severity="info" 
                sx={{ m: 2, mb: 0 }}
              >
                Código detectado: <strong>{scannedCode}</strong>
                {scannedCode.startsWith('{') && (
                  <Typography variant="caption" display="block" sx={{ mt: 1, fontStyle: 'italic' }}>
                    Procesando código JSON...
                  </Typography>
                )}
              </Alert>
            )}

            <Box sx={{ position: 'relative', minHeight: 400 }}>
              <video
                id="scanner-video"
                style={{
                  width: '100%',
                  height: '400px',
                  objectFit: 'cover',
                  backgroundColor: '#000'
                }}
                playsInline
                muted
              />
              
              {/* Overlay de escaneo */}
              <Box
                sx={{
                  position: 'absolute',
                  top: '50%',
                  left: '50%',
                  transform: 'translate(-50%, -50%)',
                  border: '3px solid #4CAF50',
                  width: 200,
                  height: 200,
                  borderRadius: 2,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backgroundColor: 'rgba(76, 175, 80, 0.1)',
                  '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: -3,
                    left: -3,
                    right: -3,
                    bottom: -3,
                    border: '2px solid rgba(76, 175, 80, 0.3)',
                    borderRadius: 2,
                    animation: 'pulse 2s infinite',
                  }
                }}
              >
                {isScanning && (
                  <CircularProgress 
                    size={40} 
                    sx={{ color: '#4CAF50' }}
                  />
                )}
              </Box>

              {/* Instrucciones */}
              <Box
                sx={{
                  position: 'absolute',
                  bottom: 16,
                  left: 16,
                  right: 16,
                  backgroundColor: 'rgba(0, 0, 0, 0.7)',
                  color: 'white',
                  p: 2,
                  borderRadius: 1,
                  textAlign: 'center'
                }}
              >
                <Typography variant="body2">
                  {isScanning ? 'Procesando código...' : 'Apunta la cámara hacia el código QR o de barras'}
                </Typography>
              </Box>
            </Box>
          </DialogContent>

          <DialogActions sx={{ p: 2, backgroundColor: theme.palette.grey[50] }}>
            <Button
              onClick={handleCloseScanner}
              variant="outlined"
              startIcon={<CloseIcon />}
              sx={{ textTransform: 'none' }}
            >
              Cancelar
            </Button>
            <Typography variant="body2" sx={{ color: theme.palette.text.secondary, ml: 2 }}>
              Formatos soportados: QR Code, Code 128, EAN-13, UPC-A
            </Typography>
          </DialogActions>
        </Dialog>
      </Box>
    </>
  )
}


